import { FC } from 'react'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import { pickRepresentativePhone } from '../../../../../../util/pickRepresentativePhone'

type Props = {
  contactAddress: ContactAddressType
}

const ThirdCardContent: FC<Props> = (props) => {
  const { contactAddress } = props

  const dateFormat = (date: string) => {
    let res = ''
    date
      .split('T')[0]
      .split('-')
      .forEach((t) => (res += t + '/'))

    return res.slice(0, -1)
  }

  // 代表電話番号の選定はエクスポートと共通ロジックを使用（画面表示とCSVを一致させる）
  const displayPhone = pickRepresentativePhone(contactAddress)

  return (
    <div className="switcher:short3">
      <div className="flex:wrap:start">
        <span className="me-1" id="phone">
          電話:
        </span>
        {displayPhone ? (
          <span className="text-bold me-3">
            <a href={`tel:${displayPhone}`}>{displayPhone}</a>
          </span>
        ) : (
          <span>なし</span>
        )}
      </div>

      <div className="flex:wrap:start">
        <span className="me-1" id="telExtension">
          内線番号:
        </span>
        {contactAddress.telExtension ? (
          <span className="text-bold me-3">
            <a href={`tel:${contactAddress.telExtension}`}>
              {contactAddress.telExtension}
            </a>
          </span>
        ) : (
          <span>なし</span>
        )}
      </div>

      <div className="flex:wrap:start">
        <span className="me-1" id="email">
          メール:
        </span>
        {contactAddress.email ? (
          <span className="text-bold me-3 card-email">
            <a href={`mailto:${contactAddress.email}`}>
              {contactAddress.email}
            </a>
          </span>
        ) : (
          <span>なし</span>
        )}
      </div>

      <span id="createDate">
        最終更新日：
        {(contactAddress.updatedDate &&
          dateFormat(contactAddress.updatedDate)) ||
          dateFormat(contactAddress.createdDate)}
      </span>
    </div>
  )
}

export default ThirdCardContent
